import React, { useEffect, useState ,useContext,useRef} from "react";

import {
  SimpleGrid,
  Select,
  useToast,
  Button,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Wrap,
  WrapItem,
  Center
} from "@chakra-ui/react";
import UserCard from "./UserCard/UserCard";
import { BsSearch } from "react-icons/bs";
import { IconButton, VStack, Box } from "@chakra-ui/react";
import axios from "axios";
import AdminLogin from "../AdminNav/Login";
import { MyContext } from "../../MyProvider";


import { FilterTabs, Ledger, PageHeader, Pagination, SearchField, matchesSearch } from "../../components/ui";
import { API_URL } from "../../Apis/config";

function Users() {
//appointment card

  // const { id } = useParams();
  const {appointData,appointApi}=useContext(MyContext);
  // const [update, setUpdate] = useState(false);
  const [filter,setFilter]=useState("Pending");//colored filters on top of ui
  const [counts, setCounts] = useState({
    total: 0,
    completed: 0,
    pending: 0,
    scheduled:0,
    latest:0,
  
  });//count of colored filters on top of ui
  
  const [appointments, setAppointments] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [appointmentsPerPage] = useState(8);
  // const [totalAppointment, setTotalAppointment] = useState(0);
  // const [pendingAppointment, setPandingAppointment] = useState(0);
  // const [completedAppointment, setCompletedAppointment] = useState(0);
  const searchOption=useRef('name');
  const toast = useToast();
  useEffect(() => {
    const updatedCounts = {
      total: appointData.length,
      completed: appointData.filter((ele) => ele.appointmentStatus === "Completed").length,
      pending: appointData.filter((ele) => ele.appointmentStatus === "Pending").length,
      scheduled:appointData.filter((ele) => ele.appointmentDate == today).length,
      latest:appointData.filter((ele) => ele.bookingDate == today).length
    };
    setCounts(updatedCounts);

  }, [appointData]);

  useEffect(() => {
    switch (filter) {
      case "Completed":
        setAppointments(appointData.filter((ele) => ele.appointmentStatus === "Completed"));
        break;
      case "Pending":
        setAppointments(appointData.filter((ele) => ele.appointmentStatus === "Pending"));
        break;
      case "Scheduled":setAppointments(appointData.filter((ele) => ele.appointmentDate == today));break;
      case "Latest":setAppointments(appointData.filter((ele) => ele.bookingDate == today));break;  
      default:
        setAppointments([...appointData]);
        break;
    }  }, [filter,appointData]);


    useEffect(()=>{
      if(currentPage!=1){setCurrentPage(1)};
    },[filter]);
      

    useEffect(()=>{
  
      if(filter!="Appoint"){setFilter("Appoint")};
      if(currentPage!=1){setCurrentPage(1)};
      if(search==""){setAppointments([...appointData])}
      else if(search.length>2){setAppointments(appointData.filter((el)=>matchesSearch(el,searchOption.current,search)))}
      },[search]);
      

      const today=new Date().toLocaleDateString("en-GB");
      
  // Get current appointments based on pagination
  const indexOfLastAppointment = currentPage * appointmentsPerPage;
  const indexOfFirstAppointment = indexOfLastAppointment - appointmentsPerPage;
  const currentAppointments = appointments.slice(
    indexOfFirstAppointment,
    indexOfLastAppointment
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const goToNextPage = () => {
    if (currentPage < Math.ceil(appointments.length / appointmentsPerPage)) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };


  const getHeaderStyle = (name) => ({
    cursor: "pointer",
    backgroundColor: filter === name ? "yellow" : "transparent",
    color: filter === name ? "black" : "white"
    
  });

  const updateAppoint=async()=>{

    await appointApi();
  };


  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }

  const handleSubmit = (formData, id) => {
    // console.log(formData);
    // Here, you can use the formData object as the payload
    // to send it to your backend or perform any necessary actions
    axios
      .patch(
        `${API_URL}/appointment/${id}`,
        formData
      )
      .then((res) => {
        updateAppoint();
        toast({
          title: "Appointment updated",
          description: "Appointment has been updated successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:"Error occured while updating appointment",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };
  const onDeleteConfirm = (id) => {
    // setIsDeleteAlertOpen(false);
    // Perform delete logic here
    axios
      .delete(`${API_URL}/appointment/${id}`)
      .then((res) => {
        updateAppoint();
        toast({
          title: "Appointment deleted",
          description: "Appointment has been deleted successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        // Perform any necessary actions after successful deletion
      })
      .catch((err) => {
        toast({
          title: "Error",
          description:
            "Error occured while deleting appointment",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };
  return (
    <>
      <PageHeader title="Appointments" subtitle="Consultations booked with the office">
        <SearchField
          options={[{ value: "name", label: "Name" }, { value: "phone", label: "Mobile" }, { value: "bookingDate", label: "Submission" }, { value: "appointmentDate", label: "Scheduled" }]}
          onFieldChange={(event)=>{searchOption.current=event.target.value;}}
          onSearch={(e) => setSearch(e.target.value)}
        />
      </PageHeader>
      <FilterTabs
        active={filter}
        onChange={handleFilterChange}
        tabs={[
          { key: "Pending", label: "Pending", count: counts.pending },
          { key: "Completed", label: "Completed", count: counts.completed },
          { key: "Scheduled", label: "Today", count: counts.scheduled },
          { key: "Latest", label: "Booked today", count: counts.latest },
          { key: "Appoint", label: "All", count: counts.total },
        ]}
      />
      <Ledger
        columns="minmax(0,1.6fr) minmax(0,1fr) minmax(0,1fr) 110px 300px"
        heads={["Name", "Scheduled", "Submitted", "Status", ""]}
        isEmpty={appointments.length === 0}
        emptyText="No appointments here. Try another filter or clear the search."
      >
        {currentAppointments.map((apt) => (
          <UserCard
            key={apt._id}
            User={apt}
            Update={handleSubmit}
            Delete={onDeleteConfirm}
          />
        ))}
      </Ledger>
      <Pagination
        currentPage={currentPage}
        pageCount={Math.ceil(appointments.length / appointmentsPerPage)}
        onPrevious={goToPreviousPage}
        onNext={goToNextPage}
        onPage={paginate}
      />
    </>
  );
}

export default Users;
